var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28058 6C7.76978 6 9.72662 10.4029 9.72662 10.8921C9.72662 11.8705 8.25899 12.8489 7.76978 13.8273C7.28058 14.8058 8.25899 15.7842 9.23741 16.7626C9.61899 17.1442 11.1942 18.7194 12.1727 18.2302C13.1511 17.741 14.1295 16.2734 15.1079 16.2734C15.5971 16.2734 20 18.2302 20 18.7194C20 20.6763 18.5324 22.1439 17.0647 22.6331C15.5971 23.1223 14.6187 23.1223 12.6619 22.6331C10.705 22.1439 9.23741 21.6547 6.79137 19.2086C4.34532 16.7626 3.85612 15.295 3.36691 13.3381C2.8777 11.3813 2.8777 10.4029 3.36691 8.93525C3.85612 7.46763 5.32374 6 7.28058 6Z",
    stroke: "#3A3A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.07795ceba993b48c1f90ef7677b1dfaa.svg";
export { ForwardRef as ReactComponent };